import React from "react";

import { TeaserHeadingType } from "types";
import { getTeaserTitle } from "utils";
import { Play } from "assets/icons";
import { Label, LabelProps } from "components/label/Label";
import classNames from "classnames";

export interface TeaserProps {
  url: string;
  title: string;
  intro?: string;
  label?: string;
  image?: string;
  headingType?: TeaserHeadingType;
  isVideo?: boolean;
  mediaLabel?: LabelProps;
  teaserType?: string;
}

export const DefaultTeaser: React.FC<TeaserProps> = ({
  url,
  title,
  intro,
  label,
  image,
  headingType = TeaserHeadingType.h2,
  isVideo,
  mediaLabel,
  teaserType,
}) => (
  <a
    href={url}
    className={classNames("teaser", [teaserType && `is-${teaserType}`])}
  >
    {image && (
      <div className="teaser__media">
        <img className="teaser__image" src={image} alt="" />
        {isVideo && <Play />}
        {mediaLabel && (
          <span className="teaser__media-label">
            <Label {...mediaLabel} />
          </span>
        )}
      </div>
    )}

    <div className="teaser__info">
      {getTeaserTitle(title, headingType, ["teaser__title"])}

      {label && <div className="teaser__label">{label}</div>}

      {intro && (
        <p
          className="teaser__description"
          dangerouslySetInnerHTML={{ __html: intro }}
        />
      )}
    </div>
  </a>
);
